import { Component, HostListener, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { StockDataSourceService } from '../../core/data-sources/stock-data-source.service';
import { FullLoaderService } from 'src/app/core/services/full-loader.service';
import { SnackBarService } from '../../core/services/snack-bar.service';
import { Subject } from 'rxjs';
import { filter, delay, takeUntil } from 'rxjs/operators';
import { LayoutService } from 'src/app/core/data-sources/layout.service';
import { WarehouseMapTaskPositionViewComponent } from './warehouse-map-task-position-view/warehouse-map-task-position-view.component';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {
  map;
  stockCount;
  isMapLoaded: boolean;
  notificationAlreadyOpen = false;
  notificationData: {
    type: string,
    title: string,
    message: string
  };
  openTip = false;
  @ViewChild('notification', { static: true }) notificationTmpl;
  @ViewChild('mapComponent', { static: true }) mapComponent: WarehouseMapTaskPositionViewComponent;
  private destroy$ = new Subject();
  selectedPositionIds: string[] = [];
  lastHighlightedGroupId: string;

  @HostListener('wheel', ['$event']) preventZoomOnWHeel(event: WheelEvent) {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }
  }
  @HostListener('window:keydown', ['$event']) preventZoomOnCtrlPlus(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.key === '=')) {
      this.openFeedbackOnce();
      event.preventDefault();
    }
  }

  constructor(private router: Router,
              private layoutService: LayoutService,
              private stockService: StockDataSourceService,
              public fullLoaderService: FullLoaderService,
              private snackbarService: SnackBarService) {
    this.router.events.subscribe(routerEvent => {
      if (routerEvent instanceof NavigationEnd) {
        if (routerEvent.urlAfterRedirects !== '/map') {
          location.reload();
        }
      }
    });
  }


  public navigate(excelCoord: string) {
    this.mapComponent.goTo(100, 1000);
  }

  ngOnInit(): void {
    this.fullLoaderService.open();
    this.getMaps().then(() => {})
      .catch((err) => console.log(err));
    this.stockService.reloadMap$.pipe(
      filter(value => !!value),
      delay(5000),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      location.reload();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getMaps() {
    this.map = await this.stockService.getGroundPosition(false);
    this.stockService.reloadMap$.next(false);
    return this.map;
  }

  toDashboard() {
    this.router.navigate(['in']);
  }

  mapLoaded() {
    this.isMapLoaded = true;
    this.closeLoader();
  }

  closeLoader() {
    if (this.map && this.isMapLoaded) {
      this.fullLoaderService.close();
    }
  }

  openFeedbackOnce(): void {
    if (this.notificationAlreadyOpen) {
      return;
    }
    this.notificationAlreadyOpen = true;
    this.openTip = true;
    this.notificationData = {
      type: 'warning',
      title: 'ATENÇÃO',
      message: 'Para dar zoom, utilize o scroll do mouse.'
    };
    this.snackbarService.showFeedback(this.notificationTmpl, this.notificationData, '1');
    setTimeout(() => {
      this.snackbarService.hideNotification('1');
      this.notificationAlreadyOpen = false;
    }, 5000);
  }

  showLoader(show: boolean) {
    if (show) {
      this.fullLoaderService.open();
    } else {
      this.fullLoaderService.close();
    }
  }

  async applyFilter(filterParams: { value: string, strict: boolean }) {
    const value = filterParams.value;
    const strict = filterParams.strict;
    if (typeof value !== 'string' || !value) return;
    const searchValue = value.trim();
  
    if (!searchValue && this.mapComponent) {
      this.mapComponent.clearHighlight();
      this.mapComponent.drawMap(this.map);
      return;
    }

    try {
      this.fullLoaderService.open();
      const positions = await this.layoutService.getFilteredMap(searchValue, strict);
      // const palletsData = await this.layoutService.getFilteredMapCrates(searchValue);
      const filteredPositions = positions.filter(pos => pos.hasPallet);
      
      if (filteredPositions && filteredPositions.length > 0) {
        this.mapComponent.drawMapWithFilter(this.map, filteredPositions);
      } else {
        this.mapComponent.drawMapWithFilter(this.map, []);
      }
    } catch (error) {
      this.snackbarService.showFeedback(this.notificationTmpl, {
        type: 'error',
        title: 'Erro',
        message: 'Erro ao aplicar filtro. Tente novamente.'
      }, '3');
      setTimeout(() => {
        this.snackbarService.hideNotification('3');
      }, 3000);
    } finally {
      setTimeout(() => {
        this.fullLoaderService.close();
      }, 2000);
    }
  }

  clearFilter(clear: boolean) {
    if (!clear) return;
    this.fullLoaderService.open();
    if (this.mapComponent) {
      this.mapComponent.clearHighlight();
      this.mapComponent.drawMap(this.map);
      setTimeout(() => {
        this.fullLoaderService.close();
      }, 3000);
    }
  }

  groupClicked(id) {
    if (this.lastHighlightedGroupId === id) {
      this.selectedPositionIds = [];
      this.lastHighlightedGroupId = null;
      return;
    }

    if (!this.map) { 
      return; 
    }

    const positions = this.map.filter(p => {
      if (p?.groupId) {
        return p.groupId === id || p.groundPositionGroupId === id;
      } else {
        return p.type === id; // se a posição não tem groupId, usa o type para agrupar
      }
    }).map(p => p.rfId);
    this.selectedPositionIds = positions;
    this.lastHighlightedGroupId = id;
  }
}
